import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { verifyEmailLogin } from '../../api/user';
import { loginAndRedirect } from '../../common/auth';
import TaskonioLoader from '../../components/UI/Loader';

export default function VerifyEmailLogin() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // User ID = uid
    const userId = searchParams.get('uid');
    // Magic Link Token = mlt
    const token = searchParams.get('mlt');

    if (!userId || !token) {
      console.log('throw error as both are required');
      alert('Both user id and token are required to verify email login');
    } else {
      verifyEmailLogin(Number(userId), token)
        .then((res) => {
          void loginAndRedirect(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []);

  return (
    <div className="flex items-center justify-center">
      <TaskonioLoader></TaskonioLoader>
    </div>
  );
}
